Vue.config.devtools = true

import Vue from 'vue'
import App from './App.vue'
import '@babel/polyfill'
import 'mutationobserver-shim'
import './plugins/bootstrap-vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios)

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

// Font Awesome Icons
import { faAd } from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { faCode } from '@fortawesome/free-solid-svg-icons'
import { faCodeBranch } from "@fortawesome/free-solid-svg-icons";
import { faCoins } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faFigma } from "@fortawesome/free-brands-svg-icons";
import { faGoogle } from '@fortawesome/free-brands-svg-icons'
import { faLaravel } from "@fortawesome/free-brands-svg-icons";
import { faLayerGroup } from "@fortawesome/free-solid-svg-icons";
import { faMailchimp } from '@fortawesome/free-brands-svg-icons'
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faRocket } from '@fortawesome/free-solid-svg-icons'
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { faVuejs } from "@fortawesome/free-brands-svg-icons";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { faWordpress } from "@fortawesome/free-brands-svg-icons";

library.add(faAd)
library.add(faCheckCircle)
library.add(faCircle)
library.add(faCode)
library.add(faCodeBranch)
library.add(faCoins)
library.add(faEnvelope)
library.add(faFigma)
library.add(faGoogle)
library.add(faLaravel)
library.add(faLayerGroup)
library.add(faMailchimp)
library.add(faPhone)
library.add(faRocket)
library.add(faSearch)
library.add(faVuejs)
library.add(faTimesCircle)
library.add((faWordpress))

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: function (h) { return h(App) }
}).$mount('#app')
